/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { InlineObject } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface ShowPublicTourPdfServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Show pdf
     * 
     * @param tour The tour ID
     */
    getPublicTourPdf(tour: number, extraHttpRequestParams?: any): Observable<object>;

}
